import { render, staticRenderFns } from "./TotalPrice.vue?vue&type=template&id=accc168e&scoped=true"
import script from "./TotalPrice.vue?vue&type=script&lang=js"
export * from "./TotalPrice.vue?vue&type=script&lang=js"
import style0 from "./TotalPrice.vue?vue&type=style&index=0&id=accc168e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc168e",
  null
  
)

export default component.exports